// extracted by mini-css-extract-plugin
export var grid = "_1k-0";
export var span1 = "_1k-2";
export var span10 = "_1k-b";
export var span10L = "_1k-z";
export var span10M = "_1k-n";
export var span10Xl = "_1k-1b";
export var span11 = "_1k-c";
export var span11L = "_1k-10";
export var span11M = "_1k-o";
export var span11Xl = "_1k-1c";
export var span12 = "_1k-d";
export var span12L = "_1k-11";
export var span12M = "_1k-p";
export var span12Xl = "_1k-1d";
export var span1L = "_1k-q";
export var span1M = "_1k-e";
export var span1Xl = "_1k-12";
export var span2 = "_1k-3";
export var span2L = "_1k-r";
export var span2M = "_1k-f";
export var span2Xl = "_1k-13";
export var span3 = "_1k-4";
export var span3L = "_1k-s";
export var span3M = "_1k-g";
export var span3Xl = "_1k-14";
export var span4 = "_1k-5";
export var span4L = "_1k-t";
export var span4M = "_1k-h";
export var span4Xl = "_1k-15";
export var span5 = "_1k-6";
export var span5L = "_1k-u";
export var span5M = "_1k-i";
export var span5Xl = "_1k-16";
export var span6 = "_1k-7";
export var span6L = "_1k-v";
export var span6M = "_1k-j";
export var span6Xl = "_1k-17";
export var span7 = "_1k-8";
export var span7L = "_1k-w";
export var span7M = "_1k-k";
export var span7Xl = "_1k-18";
export var span8 = "_1k-9";
export var span8L = "_1k-x";
export var span8M = "_1k-l";
export var span8Xl = "_1k-19";
export var span9 = "_1k-a";
export var span9L = "_1k-y";
export var span9M = "_1k-m";
export var span9Xl = "_1k-1a";
export var stretch = "_1k-1";